<app-modal-container *ngIf="!isLoadingState"
  [bigSize]="false"
  [titleDirection]="'centered'"
  class="'w-[27.03125rem]'"
  [title]="wrapper.metricName + ': ' + (wrapper.period | date: 'MMMM yyyy')"
  [buttons]="modalButtons"
  (closeButtonClicked)="close()">
  <div #componentContainer class="green-scroll w-[43.4375rem] max-h-[35rem] flex flex-col gap-0.9375">
      @if (isFromMetricSharedLinkPage && isEditEnabled) {
        <div *ngIf="isFromMetricSharedLinkPage" class="bg-color-orange-2-opacity-0p3 br-0p5 border-orange-10 padding-0p5 centered-row-container row-gap-0p5">
          <app-all-icons class="orange-10 icon-size-1p25" [iconNameAndStyling]="'exclamation.svg'"/>
          <span class="font-3 font-medium">
            Unlike other metrics, file uploads are saved before submission.
          </span>
        </div>
      }
      @if (fileBoxNodes.length) {
        <div class="flex gap-0.625 button-height-2p5">
          <app-button
            *ngIf="isEditEnabled"
            class="w-full"
            data-qa="attach-documents"
            [additionalClasses]="'w-full'"
            [bordersSquaredShape]="'full'"
            [type]="'accent'"
            [size]="'medium'"
            [iconName]="'attach.svg'"
            (buttonClick)="showUploadModal()">
            Add attachment
          </app-button>
          <app-button
            data-qa="download-documents"
            class="w-full"
            [additionalClasses]="'w-full'"
            [bordersSquaredShape]="'full'"
            [type]="'default'"
            [size]="'medium'"
            [iconName]="'excel.svg'"
            (buttonClick)="downloadAll()">
            Download all
          </app-button>
        </div>
        <div class="flex gap-0.625 flex-col items-center justify-center overflow-auto">
          @for (node of fileBoxNodes; track $index) {
            <div
              *ngVar="'node-line-' +  $index as nodeLineId"
              [attr.data-qa]="'kpi-document-node-line-' +  $index"
              [id]="nodeLineId"
              class="flex flex-grow self-stretch rounded p-0.625 kpi-document-item clickable"
              (click)="previewDocument(node)">
              <div
                [attr.data-qa]="'node-' +  $index"
                class="flex flex-grow items-center gap-0.78125 overflow-hidden cursor-pointer"
                (mouseenter)="activateTitleNameTooltip(nodeLineId, node.title, $index)"
                (mouseleave)="toolTipForDocumentName.show = false">
                <app-all-icons [iconNameAndStyling]="(node.title | fileTypeIcon)+'; icon-size-1p25'"/>
                <span
                  [attr.data-qa]="'node-title' + $index"
                  [id]="'node-title' + $index"
                  class="font-3 font-medium black-12 truncate flex-grow">{{ node.title }}
                </span>
              </div>
              <div
                [attr.data-qa]="'kpi-documents-button-wrapper' +  $index"
                [id]="'kpi-documents-button-wrapper' + $index"
                class="items-center gap-[0.25rem] flex">
                <app-all-icons
                  [attr.data-qa]="'preview-button-' +  $index"
                  [id]="'preview-button' + $index"
                  [iconNameAndStyling]="'eye.svg; main-8; icon-size-1p125; clickable'"
                  (click)="previewDocument(node)"
                  (mouseenter)="activateTooltip('preview-button' + $index, 'View')"
                  (mouseleave)="toolTipSettings.show = false"
                />
                <app-all-icons
                  [attr.data-qa]="'download-button-' +  $index"
                  [id]="'download-button' + $index"
                  [iconNameAndStyling]="'excel.svg; black-12; icon-size-1p125; clickable'"
                  (click)="$event.stopPropagation(); onDownloadBoxFile(node)"
                  (mouseenter)="activateTooltip('download-button' + $index, 'Download')"
                  (mouseleave)="toolTipSettings.show = false"
                />
                <app-all-icons *ngIf="isEditEnabled"
                  [attr.data-qa]="'delete-button-' +  $index"
                  [id]="'delete-button' + $index"
                  [iconNameAndStyling]="'delete.svg; red-11; icon-size-1p125; clickable'"
                  (click)="$event.stopPropagation(); openModalDeletion(node)"
                  (mouseenter)="activateTooltip('delete-button' + $index, 'Delete')"
                  (mouseleave)="toolTipSettings.show = false"
                />
              </div>
            </div>
          }
        </div>
      } @else {
        <app-empty-state-standard
          data-qa="kpi-empty-data-state"
          [heading]="'No documents yet'"
          [buttonText]="'Attach documents'"
          [buttonIconName]="'attach.svg'"
          [isAdmin]="isEditEnabled"
          (buttonClick)="showUploadModal()"/>
      }
  </div>
</app-modal-container>

<app-modal-container
  *ngIf="showBoxElements.preview"
  data-qa="kpi-documents-preview-modal"
  class="boxBox"
  [title]="docsAiService.getSelectedFile()?.fileName"
  [titleStyles]="'max-w-[80rem]'"
  [buttons]="{close: true}"
  [bigSize]="true"
  (closeButtonClicked)="closePreviewModal()">
  <div class="position-rel min-w-[80rem] flex gap-1.25" [ngClass]="{'h-[39rem]': isDocumentChatSupported}">
    <div #previewContainer class="preview-container {{isDocumentChatSupported ? 'min-w-[53rem] !h-[39rem]' : 'min-w-[80rem]'}}"></div>
    <app-document-chat *ngIf="isDocumentChatSupported" class="flex grow"/>
  </div>
</app-modal-container>

<app-modal-container
  *ngIf="showBoxElements.upload"
  [buttons]="{close: true}"
  [bigSize]="true"
  (closeButtonClicked)="this.wrapper.isUploadBoxOnStartNeeded ? closeBoxUploadModalAndMainModal() : closeOnlyBoxUploadModal() ">
  <div class="position-rel w-[50rem] h-[39rem] ">
    <div #uploadContainer class="w-full h-full"></div>
  </div>
</app-modal-container>

<app-modal-dialog
  *ngIf="nodeForDeletionWrapper.showModalDeletion"
  [header]="'Delete ' + nodeForDeletionWrapper.displayName"
  [mainText]="[]"
  [useStandardList]="true"
  [addAdditionalText]="true"
  (isConfirmed)="deleteFile($event)"/>


<app-tooltip
  *ngIf="toolTipSettings.show"
  [title]="toolTipSettings.title"
  [coordinates]="toolTipSettings.coordinates"
/>


@if (toolTipForDocumentName.show) {
  <app-tooltip
    [coordinates]="toolTipForDocumentName.coordinates"
    [freezeOnHover]="false"
    [title]="toolTipForDocumentName.showFileName ? '' : toolTipForDocumentName.title">
    <div *ngIf="toolTipForDocumentName.showFileName" class="flex flex-col items-start">
    <span class="!text-[0.625rem] font-medium break-words max-w-[30rem] whitespace-normal">
      {{toolTipForDocumentName.text}}
    </span>
      <span class="!text-[0.5rem] opacity-90">View</span>
    </div>
  </app-tooltip>
}

